export const colors = {
  primary: "#0B8E1C",
  white: "#FFFFFF",
  secondary: "#DDEA38",
  gray2: "#C4C4C466",
  gray1: "#2C2C2C"
}